import { t } from "@lingui/core/macro";
import { QueryCache, QueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { installLoaderWatchdog } from "./loader-watchdog";
import * as paths from "./paths";
import { addToast } from "@heroui/react";

export const api = paths;

const cacheIgnoreNotifyThrow = [
  "getOrganization",
  "getCashRegisterHasClosedYesterday",
  // Each analytics card shows its own error; a toast per card floods the page.
  "analyticsV2Metric",
  // The cancel modal shows its own alert and refuses to confirm until the charge is
  // known, so a toast on top of it says the same thing twice.
  "customer-subscription-early-exit",
];

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000,
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(800 * 2 * attemptIndex, 5000),
    },
  },
  queryCache: new QueryCache({
    onError(error, query) {
      if (cacheIgnoreNotifyThrow.some((key) => query.queryKey.includes(key)))
        return;
      notifyAndThrow(error);
    },
  }),
});

installLoaderWatchdog(queryClient);

function notifyAndThrow(err: unknown) {
  const message =
    (err instanceof AxiosError && err.response?.data?.error) ||
    (err instanceof Error && err.message) ||
    t`Prišlo je do sistemske napake`;

  addToast({
    title: t`Napaka`,
    description: message,
    color: "danger",
  });
}
